import React, { useState, useEffect, useCallback } from "react";
import { producaov2 as api } from "../../../../services/apis";
import { Icon, Pagination } from "semantic-ui-react";
import {
  Container,
  Content,
  Title,
  ContainerInputSearch,
  Input,
  CreateButton,
  SemanticTable,
  ContainerPaginate,
} from "./styled";
import swal from "sweetalert";
import { withRouter } from "react-router-dom";
import AdminMenu from "../../../../components/Admin/MenuDetalhes/AdminMenu";
import ScrollingModal from "../../../../components/Admin/Empresas/ListarSolicitacoes/listagem/ModalSolicitacoesEmpresas";
import Back from "../../../../components/Admin/Empresas/ListarSolicitacoes/listagem/Back";
import { Select } from "../criarEmpresas/styled";

const ListagemSolicitacoesEmpresas = (props) => {
  const [solicitacoesEmpresas, setSolicitacoesEmpresas] = useState([]);
  const [search, setSearch] = useState("");
  const [statusSearch, setStatusSearch] = useState(3);
  const [currentPage, setCurrentPage] = useState(1);

  const [pages, setPages] = useState(0);

  useEffect(() => {
    loadSolicitacoesEmpresas();
  }, [currentPage]);

  const loadSolicitacoesEmpresas = useCallback(async () => {
    try {
      const params = {
        page: currentPage,
      };

      if (search) {
        params.search = search;
      }

      if (statusSearch && statusSearch !== 3) {
        params.statusSearch = statusSearch;
      }

      const response = await api.get("/admin/empresas/solicitacoes/listagem", {
        params,
      });
      const { solicitacoesEmpresas, count } = response.data;

      let array = {
        local: "SolicitacoesEmpresas",
        texto: `listou as Solicitações de planos para as empresas`,
      };
      await api.post("system_logs", { acao: JSON.stringify(array) });
      setSolicitacoesEmpresas(solicitacoesEmpresas);
      setPages(count);
    } catch (err) {
      console.error(err);
      swal("Não foi possível carregar as Solicitações", "", "").then((res) =>
        props.history.push("/")
      );
    }
  }, [currentPage, search, statusSearch]);

  const status = [
    { texto: "Não iniciado" },
    { texto: "Em andamento" },
    { texto: "Finalizado" },
  ];

  return (
    <>
      <Container>
        <AdminMenu />
        <Content>
          <Back />
          <Title>Listagem de solicitação de Empresas</Title>

          <ContainerInputSearch className="ui fluid left icon input">
            <Input
              type="search"
              placeholder="Procurar Solicitação"
              value={search}
              onChange={(e) => setSearch(e.target.value)}
            />
            <Icon name="search icon" />

            <CreateButton onClick={loadSolicitacoesEmpresas}>
              Procurar
            </CreateButton>
          </ContainerInputSearch>
          <Select onChange={(e) => setStatusSearch(e.target.value)}>
            <option value={3}>Todos</option>
            {status.map((status, index) => (
              <option value={index}>{status.texto}</option>
            ))}
          </Select>

          <SemanticTable size="big" celled>
            <SemanticTable.Header>
              <SemanticTable.Row>
                {/* <SemanticTable.HeaderCell>
                  id da Solicitação
                </SemanticTable.HeaderCell> */}
                <SemanticTable.HeaderCell>id Empresa</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>
                  Nome da Empresa
                </SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Curso</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Licenças</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>Andamento</SemanticTable.HeaderCell>
                <SemanticTable.HeaderCell>
                  editar andamento
                </SemanticTable.HeaderCell>
              </SemanticTable.Row>
            </SemanticTable.Header>
            <SemanticTable.Body>
              {solicitacoesEmpresas?.map((solicitacao, index) => (
                <SemanticTable.Row key={index}>
                  {/* <SemanticTable.Cell>{solicitacao.id}</SemanticTable.Cell> */}
                  <SemanticTable.Cell>
                    {solicitacao.id_empresa}
                  </SemanticTable.Cell>
                  <SemanticTable.Cell>
                    {solicitacao.empresa.nome}
                  </SemanticTable.Cell>
                  <SemanticTable.Cell>{solicitacao.curso}</SemanticTable.Cell>
                  <SemanticTable.Cell>
                    {solicitacao.licencas}
                  </SemanticTable.Cell>
                  <SemanticTable.Cell>
                    {status[solicitacao.status].texto}
                  </SemanticTable.Cell>
                  <SemanticTable.Cell>
                    <ScrollingModal empresa={solicitacao} />
                  </SemanticTable.Cell>
                </SemanticTable.Row>
              ))}
            </SemanticTable.Body>
          </SemanticTable>
          <ContainerPaginate>
            <Pagination
              defaultActivePage={1}
              ellipsisItem={null}
              // siblingRange={1}
              totalPages={pages}
              onPageChange={(e, f) => setCurrentPage(f.activePage)}
              page={currentPage}
            />
          </ContainerPaginate>
        </Content>
      </Container>
    </>
  );
};

export default withRouter(ListagemSolicitacoesEmpresas);
